export const COUNTRY_INDEX = 0
export const LOCATION_INDEX = 1

export const PRICE_LIST_DETAILS_FORM_ID = 'price-list-details-form'
